import baseRoute from '../baseRoute';

type RouteDefinition = `${typeof baseRoute}/${number | ':accountId'}/activate`;

export const ROUTE: RouteDefinition = `${baseRoute}/:accountId/activate`;

export const URL = (accountId: number): RouteDefinition => `${baseRoute}/${accountId}/activate`;
